export function removeAllExceptNumbers (input: string): string {
  const regEx = /[^\d]/g
  return input.replace(regEx, '')
}

export const firstLetterToUpperCaseHandler = (str: string) => {
  return str.replace(/^[a-z]/, (match) => match.toUpperCase())
}

export const getNumberFromString = (string: string): number => {
  let result = 0
  for (let i = 0; i < string.length; i++) {
    result += string[i]?.charCodeAt(0) ?? 0
  }

  return result
}

export function removePartStringFromString (initialString: string, removedString: string) {
  const regexp = new RegExp(`${removedString}`, 'g')
  return initialString.replace(regexp, '')
}
